import Hero from '../components/Hero';
import '../styles/Pages.css';
function HealthcareServices({ setCurrentPage }) {
    return (
      <>
      <Hero title="Healthcare Services" image="/images/healthcareservice.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/healthcareservice.jpg" alt="Healthcare Services" />
          </div>
          <div className="service-text">
            <h3>Healthcare Services</h3>
            <p>
              Digicloudllc enhances patient care, optimizes health outcomes, and reduces costs
              through strategic healthcare consulting. They offer comprehensive staffing services
              across specialties like Acute Care, Allied Health, Medical Administration, Social
              Services, and Long-Term Care. With extensive staffing experience, Digicloudllc
              tailors solutions to meet each organization’s unique needs, using a people-centric
              approach to align talent with long-term goals.
            </p>
            <p>
              Healthcare services refer to a broad spectrum of services and solutions designed to
              maintain, restore, or improve health and well-being. These services cater to
              individuals, communities, and populations.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
          </div>
        </div>
  
        <section className="about-section">
          
        </section>
      </div>
      </>
    );
  }
  
  export default HealthcareServices;